import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Colors from '../../../../theme/colors';

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: Colors.Main.Light,
  borderRadius: '10px',
  overflow: 'hidden',
});

const ContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

const InfoMessageContainer = styled(Box)({
  flexDirection: 'row',
  padding: 16,
  backgroundColor: Colors.TestResultsRowBackground,
  display: 'flex',
  alignItems: 'center',
});

const InfoMessageContainerTopIcon = styled(InfoMessageContainer)({
  alignItems: 'flex-start',
});

const InfoIconContainer = styled(Box)({
  marginRight: 16,
  justifyContent: 'center',
  alignItems: 'center',
  paddingTop: 4,
});

const InfoMessage = styled(Typography)({
  display: 'flex',
  flex: 1,
});

InfoMessage.defaultProps = {
  variant: 'BodySmallRegular',
  color: Colors.Text.Heading,
};

const BulletList = styled('ul')({
  margin: '4px 0 0',
  paddingLeft: '20px',
});

const ValidationFailedMessageContainer = styled(Box)({
  margin: '8px 0 0',
});

export {
  Container,
  ContentContainer,
  InfoMessage,
  InfoMessageContainer,
  InfoMessageContainerTopIcon,
  InfoIconContainer,
  BulletList,
  ValidationFailedMessageContainer,
};
